import React from 'react';
import Helmet from 'react-helmet';
import LoadingScreen from '../components/LoadingScreen';

import '../assets/scss/styles.scss';

class Layout extends React.Component {
  render() {
    const { children } = this.props;

    return (
      <div id="ip-container" className="layout ip-container">
        <Helmet defaultTitle="Goose: Trusted BigCommerce Experts in New Zealand" />
        <LoadingScreen />
        {children()}
      </div>
    );
  }
}

export default Layout;



// WEBPACK FOOTER //
// ./src/layouts/index.jsx